export default __webpack_public_path__ + "static/media/card2.f9da9504.jpg";